<script>
  import Modal from "../HTMLElements/Modal.svelte";
  import { Username, FromPage, PendingLoginPassword } from "./store.js";
  import { User, getParameterByName } from "../../store.js";
  import { onMount, createEventDispatcher } from "svelte";
  import Field from "../FormField.svelte";
  import TextBox from "../HTMLElements/Textbox.svelte";
  import * as objectWrapper from "../Utils/ObjectWrapper.js";
  import * as validate from "../Utils/ValidateFormFields.js";
  import Help from "../help.svelte";
  import wrappedFetch from '../../wrappedfetch.js';
	import * as ExtractMsg from "../Utils/UserMsgFromInvalidResponse.js";

  export let showModal = false;
  export let username = '';
  export let hash = '';

let ref = null;
  let dispatch = createEventDispatcher();

  onMount(async () => {
  
    
    ref.focus();

   
  });

  let signinObj = {
    username: { value: username, isDirty: false, isValid: username != '' ,ref:null},
    password: { value: "", isDirty: false, isValid: false, ref:null },
    hash: { value: hash, isDirty: false, isValid: true, ref:null }
  };

  
  let errMsg = "";
  let recovered = false;


    const redirect = async (e) => {
      e.preventDefault();
      FromPage.set("login");
      $Username.value = signinObj.username.value;
      // Credentials were just verified against USO — carry the password
      // (in memory only) so RecreateAccount can log the user straight in
      // after they confirm their details, instead of asking them to
      // retype details they've already proven.
      $PendingLoginPassword = signinObj.password.value;
      dispatch("pageChange", "/account/recreateaccount");
    }


  const login = async e => {
   
    e.preventDefault();
 
    if (validate.validate(signinObj)) {     
      const loguserIn = await wrappedFetch("user/login", {
        method: "post",
        body: JSON.stringify(objectWrapper.unwrapObject(signinObj)),
        headers: { "Content-Type": "application/json" }
      });
      let response = await loguserIn.json();
      
      if (response.success) {
        $User = response.user;      
        if(signinObj.username.value.includes("@"))
        {
              _paq.push(['trackEvent', 'EmailLogin', signinObj.username.value])
        }
        if(response.shouldForcePasswordChange)
          dispatch("pageChange","/useraccount/changepassword");
        else if(response.isEmailValidated && hash != "")
          dispatch("pageChange", "/user/home/true");
        else if(getParameterByName("ReturnUrl") || getParameterByName("returnUrl")){
          var returnUrl =getParameterByName("ReturnUrl")|| getParameterByName("returnUrl");
          if(returnUrl.indexOf('impersonate') > -1)
          window.location.href="/impersonate";
          else
           dispatch("pageChange", returnUrl);
        }
        else
          dispatch("pageChange", "/user/home");
        
      } else {
        recovered = response.recovered;
        errMsg = response.message;

        if (recovered)
        {
          e.preventDefault();
          FromPage.set("login");
          $Username.value = signinObj.username.value;
          $PendingLoginPassword = signinObj.password.value;
          dispatch("pageChange", "/account/recreateaccount");
        }
        //errMsg = ExtractMsg.ExtractMsgsFromInvalidResponse (save, 
                             //"We have had trouble logging you in. Please try again later.", 
                              //"Problem on login: ");

      }
    } else signinObj = signinObj;
  };

  // import ForgotPassword from './ForgotPassword.svelte';
</script>

<form action="" class="box" on:submit={login} style="margin-bottom:.75rem !important">
 <div class="field">
              <a href="/">
                <span class="fas fa-arrow-left" />
                Back
              </a>
            </div>
  <Field label="Username" hasIconLeft="true">
    <span slot="inputField">
      <TextBox
        placeholder="e.g. bobsmith.uso"
        isRequired="true"
        bind:text={signinObj.username.value}
        bind:isValid={signinObj.username.isValid}
        bind:isDirty={signinObj.username.isDirty}
        bind:ref
        label="username"
        faIcon="fas fa fa-user" />
    </span>
  </Field>

  <Field label="Password" hasIconLeft="true">
    <span slot="inputField">
      <TextBox
        placeholder="**********"
        isRequired="true"
        bind:text={signinObj.password.value}
        bind:isValid={signinObj.password.isValid}
        bind:isDirty={signinObj.password.isDirty}
        bind:this = {signinObj.password.ref}
        isPassword="true"
        label="password"
        faIcon="fas fa fa-lock" />
    </span>
  </Field>

  {#if errMsg != ''}
    <div class="notification is-invalid">
      <p class="help" style="margin-bottom:0px">{@html errMsg}</p>
    </div>
  {/if}
  
  <div>
    <div>
      <button class="button is-purple is-fullwidth" style="margin-top: 10px;" on:click={recovered ? redirect : login}>
        {recovered ? 'Proceed' : 'Sign in'}
      </button>
    </div>
  </div>

  <div style="margin-top:20px;">
  <p><strong>Please note: Accounts are archived after 3 years if they have not been used.</strong></p>
  </div>
</form>

<div style="text-align:center;font-weight: 600;font-size: 1.2rem;">
  <!-- <a href="/account/forgotpassword" style="color:white"> Forgot username or password?</a> <br> -->
  <a href="/account/forgotpassword" style="color:white;"> Reset password / Forgotten username?</a> <br>

  <a href="/register/start" style="color:white"> Not registered yet?</a><br>
</div>
{#if showModal}
  <Modal bind:showModal >
   <Help
      helpId="Help19"
      showSearchOption={false}
      showContent={false}
      doAnimation={false} />
  </Modal>
{/if}
